var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper-footer"},[_c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"app-footer__inner"},[_c('div',{staticClass:"app-footer-right"},[_c('span',[_vm._v("Copyright © "),_c('span',[_vm._v(_vm._s(_vm.current)+" B2B Portal")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }